'use client'

import React, { FC, ReactElement } from 'react'
import styles from './ButtonAction.module.css'
import { ChevronRight } from '@mui/icons-material'
import Button from '@/components/button'
import classNames from 'classnames'

const ButtonAction: FC<{
	open?: boolean
	handleClick?: (evt: any) => void
	icon?: FC<{ className?: string }>
	title: string
	className?: string
	background?: 'white' | 'black' | 'gray'
}> = (props): ReactElement => {
	const classNameArrow = React.useMemo(() => {
		if (typeof props.open === 'undefined') {
			return ''
		}

		return props.open ? styles.openArrow : styles.closedArrow
	}, [props])

	return (
		<Button
			className={classNames({ [(props?.className as any)]: !!props?.className })}
			onClick={props?.handleClick}
			size="large"
			background={props?.background}
		>
			<div className={styles.label}>
				{props?.icon && <props.icon className={styles.icon} />}
				<span>{props.title}</span>
			</div>
			<ChevronRight className={classNameArrow} />
		</Button>
	)
}

export default ButtonAction
